/*
 CardPolityka

 Karta z politykami prywatnosci
  
 historia: 
  PM 2021-09-07 - start
*/

import * as React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Card, CardContent, Theme, Typography } from '@material-ui/core';

import ResponsiveImgMaterialUi from 'responsive-img-material-ui';
import MZaloga from './aplikacjeTresc/MZaloga';
import MAlert from './aplikacjeTresc/MAlert';
import MBookuj from './aplikacjeTresc/MBookuj';
import MCzytnik from './aplikacjeTresc/MCzytnik';
import MGlosowanie from './aplikacjeTresc/MGlosowanie';
import MGrafik from './aplikacjeTresc/MGrafik';
import MKelner from './aplikacjeTresc/MKelner';
import MKelnerAuto from './aplikacjeTresc/MKelnerAuto';
import MManager from './aplikacjeTresc/MManager';
import MNadzorca from './aplikacjeTresc/MNadzorca';
import MPager from './aplikacjeTresc/MPager';
import MSms from './aplikacjeTresc/MSms';
import MSmsWeb from './aplikacjeTresc/MSmsWeb';
import { Aplikacja } from '../App';

//PM 2021-09-08
//zmiana aplikacja na obiekt
interface CardPolitykaProps {
    aplikacja: Aplikacja
}

class CardPolityka extends React.Component<CardPolitykaProps & WithStyles<typeof styles>, any> {

    //PM 2021-09-08
    //zmiana aplikacja na obiekt
    selectComponent = () => {
        switch (this.props.aplikacja.value) {
            case 'mZaloga': return <MZaloga />
            case 'mAlert': return <MAlert />
            case 'mBookuj': return <MBookuj />
            case 'mCzytnik': return <MCzytnik />
            case 'mGlosowanie': return <MGlosowanie />
            case 'mGrafik': return <MGrafik />
            case 'mKelner': return <MKelner />
            case 'mKelnerAuto': return <MKelnerAuto />
            case 'mManager': return <MManager />
            case 'mNadzorca': return <MNadzorca />
            case 'mPager': return <MPager />
            case 'mSms': return <MSms />
            case 'mSmsWeb': return <MSmsWeb />
        }
    }

    //PM 2021-11-05
    //<Typography gutterBottom component="h1" variant="h6">
    //poprawka ResponsiveImgMaterialUi
    render() {
        const { classes } = this.props;

        return (
            <Card elevation={0} className={classes.card}>
                {window.innerWidth > 600 ? null :
                    (
                        <ResponsiveImgMaterialUi
                            style={{ height: "34px", width: "150px", display: 'block', margin: '0 auto', paddingBottom: '15px' }}
                            xs={require('./logo_virtual.png').default}
                            md={require('./logo_virtual.png').default}
                            lg={require('./logo_virtual.png').default}
                        />
                    )}
                <div>
                    <div style={{ width: window.innerWidth > 600 ? '66.66667%' : '100%' }} className={classes.inlineBlock}>
                        <Typography gutterBottom component="h1" variant="h6">
                            <b >{"Aplikacja " + this.props.aplikacja.text}</b>
                        </Typography>
                        <Typography gutterBottom component="p" variant="subtitle1">
                            Polityka prywatności aplikacji mobilnej
                        </Typography>
                    </div>
                    {window.innerWidth > 600 ?
                        (
                            <span style={{ float: "right", paddingRight: "5px" }} className={classes.inlineBlock}>
                                <ResponsiveImgMaterialUi style={{ height: "100%", width: "100%" }}
                                    xs={require('./logo_virtual.png').default}
                                    md={require('./logo_virtual.png').default}
                                    lg={require('./logo_virtual.png').default}
                                />
                            </span>
                        ) : null}
                </div>
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />
                <CardContent>
                    {this.selectComponent()}
                </CardContent>
            </Card>
        );
    }
}

const styles = (theme: Theme) => ({
    inlineBlock: {
        display: 'inline-block'
    },
    card: {
        paddingTop: theme.spacing(6)
    },
});

export default withStyles(styles)(CardPolityka);
